module.exports = __webpack_public_path__ + "img/covid-19.95616ad6.png";